import { call, put, select } from 'redux-saga/effects';

import { ModalType } from 'const';
import { hideModal, showModal } from 'containers/ModalManager/actions';
import { findModalByType } from 'containers/ModalManager/helpers/modalHelpers';
import { modalWindows } from 'containers/ModalManager/selectors';
import { UploadContextOptions } from 'models';
import { handleSagaError } from 'services/handleError';
import { Notifications } from 'services/Notifications';
import { intlGet } from 'utils/intlGet';

export function* createBinderDuplicate(action: { payload?: { uploadContext?: UploadContextOptions } }): Generator {
  try {
    const currentModalWindows = yield select(modalWindows);
    const foundUploadProjectModal = findModalByType(currentModalWindows, ModalType.UPLOAD_PROJECT);

    const { uploadContext }: { uploadContext?: UploadContextOptions } = action.payload || {};

    if (foundUploadProjectModal) {
      yield put(hideModal(foundUploadProjectModal.id));

      const { accepted }: { accepted: boolean } = yield call(
        [Notifications, Notifications.showConfirmation],
        {
          title: intlGet('ConfirmationWindow.Title', 'CreateDuplicate'),
          message: intlGet('ConfirmationWindow.Message', 'CreateBinderDuplicate'),
          acceptLabel: intlGet('ConfirmationWindow.Button', 'CreateDuplicate'),
          declineLabel: intlGet('ConfirmationWindow.Button', 'Cancel'),
        },
        'createDuplicateBinder',
      );

      if (!accepted) {
        yield put(showModal(ModalType.UPLOAD_PROJECT));

        return;
      }

      yield put(
        showModal(ModalType.MANAGE_BINDER, {
          disableClickOutside: true,
          uploadContext,
        }),
      );
    }
  } catch (error) {
    yield call(handleSagaError, error, 'ModalWindows.createBinderDuplicate', 'Duplicate binder');
  }
}
